import { useContext } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import MainLayoutContext from "contexts/MainLayoutContext";
import { getMainContainerBoxWidth } from "styles/AppContainer/MainContainerStyle";
import { useLocation } from "react-router-dom";

const MainContainer = ({ children, marginLeft, marginTop }) => {
  const theme = useTheme();
  const contextValue = useContext(MainLayoutContext);
  const title = contextValue?.title || "";
  const { pathname } = useLocation();
  // When CSS-rotated to landscape on portrait devices, vw/vh are visually swapped
  const isPortraitRotated = useMediaQuery("(max-width: 1279px) and (orientation: portrait)");
  // Compact header is 56px at < lg; standard is 70px. Total offset = header + 24px bottom margin.
  const isCompact = useMediaQuery(theme.breakpoints.down("lg"));
  const navOffset = isCompact ? "72px" : "94px";

  return (
    <Box
      className={title}
      sx={{
        minHeight: isPortraitRotated ? "50vw" : "50vh",
        marginTop: marginTop,
        marginLeft: {
          xs: "16px",
          lg: marginLeft,
        },
        marginRight: {
          xs: "16px",
          sm: "24px",
          md: "32px",
        },
        marginBottom: "20px",
        maxWidth: isPortraitRotated
          ? {
              xs: "calc(100vh - 32px)",
              sm: "calc(100vh - 103px)",
            }
          : {
              xs: "calc(100vw - 32px)",
              sm: "calc(100vw - 103px)",
              md: "calc(100vw - 11px)",
              lg: "calc(100vw - 104px)",
              xl: "calc(100vw - 96px)",
              xxl: "calc(100vw - 112px)",
            },
        width: "100%",
        height: isPortraitRotated ? `calc(100vw - ${navOffset})` : `calc(100vh - ${navOffset})`,
        transition: (theme) =>
          theme.transitions.create(["margin-left", "max-width"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        ...getMainContainerBoxWidth(theme, pathname),
      }}>
      {children}
    </Box>
  );
};

export default MainContainer;
